import api from "./apiV1";

export const getIncidentes = () => {
  return api.get("active-incidents");
};
